export default __webpack_public_path__ + "static/images/list-2.778e7b3f.jpg";